import script from "./shoppingCart.vue?vue&type=script&setup=true&lang=js"
export * from "./shoppingCart.vue?vue&type=script&setup=true&lang=js"

import "./shoppingCart.vue?vue&type=style&index=0&id=4d88b75e&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d88b75e"]])

export default __exports__